export const roleManagementConstants = {    
    GETSPLESHSCREEN_REQUEST: 'GETSPLESHSCREEN_REQUEST',
    GETSPLESHSCREEN_REQUEST_END: 'GETSPLESHSCREEN_REQUEST_END',
    GETSPLESHSCREEN_SUCCESS: 'GETSPLESHSCREEN_SUCCESS',
    SPLESHSCREEN_FAILURE: 'SPLESHSCREEN_FAILURE',
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    SAVESPLASH:'SAVESPLASH'
};
